import {EventReducer, ReducerFromState} from "../../../@types/reducers";

export const isInitialized = (state: ReducerFromState<EventReducer>): boolean => state.event.initializing;